import { BaseFetch } from "../main-model";
export default class TrackClaimModel extends BaseFetch {
  getTrackClaimBy = (data) =>
    this.authFetch({
      url: "track-claim/getTrackClaimBy",
      method: "POST",
      body: data,
    });
  getTrackClaimById = (data) =>
    this.authFetch({
      url: "track-claim/getTrackClaimById",
      method: "POST",
      body: data,
    });
  insertTrackClaim = (data) =>
    this.authFetch({
      url: "track-claim/insertTrackClaim",
      method: "POST",
      body: data,
    });
  updateTrackClaimById = (data) =>
    this.authFetch({
      url: "track-claim/updateTrackClaimById",
      method: "POST",
      body: data,
    });
  deleteTrackClaimById = (data) =>
    this.authFetch({
      url: "track-claim/deleteTrackClaimById",
      method: "POST",
      body: data,
    });
  getTrackClaimByClaim = (data) =>
    this.authFetch({
      url: "track-claim/getTrackClaimByClaim",
      method: "POST",
      body: data,
    });
}
